module.exports = __webpack_public_path__ + "img/02sjjs.9ed65f29.svg";